import RetailInvoice from "../../HalfA4Invoices/RetailInvoice";
import StandardReceipt from "../../HalfA4Invoices/StandardReceipt";
import CompactInvoice from "../../HalfA4Invoices/CompactInvoice";
import ClassicInvoice from "../../HalfA4Invoices/ClassicInvoice";


const InvoicePreviewRenderer = ({
  selectedSize,
  selectHALFA4Option,
  data,
  selectedTheme,
  optData
}) => {

    const commonProps = {
    data,
    selectedTheme,
    selectedSize,
    optData,
  };
  if (selectedSize !== "HALFA4") return null;
  const templates = {
    HA4RET: RetailInvoice,
    HA4SRT: StandardReceipt,
    HA4CMP: CompactInvoice,
    HA4CLS: ClassicInvoice,
  };

  const SelectedTemplate = templates[selectHALFA4Option];

  return SelectedTemplate ? <SelectedTemplate {...commonProps} /> : null;
};

export default InvoicePreviewRenderer;